const TYPE = "BMA";

export const GET_BMA_CHANNEL_RESULT = `${TYPE}_get_bma_channel_result`;
export const UPDATE_RESULT_KEY = `${TYPE}_update_result_key`;
